module.exports = __webpack_public_path__ + "img/loaderPokebola.53326fbf.svg";